import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pendingContainerClass'
})
export class PendingContainerClassPipe implements PipeTransform {
  transform(first: boolean, last: boolean) {
    if (first && last) {
      return 'pending-container';
    }
    if (!first && !last) {
      return 'pending-container-middle';
    }
    if (first) {
      return 'pending-container-first';
    }
    return 'pending-container-last';
  }
}
